import { Component, Input, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { BTStudentRouteRequest } from "../shared/BTStudentRouteRequest";
import { DataService_BusTrackerBusMaintenance } from "../shared/data.service";
import { AssignStudentsComponent } from "./assign-students/assign-students.component";

@Component({
	selector: "caass-bus-maintenance-student-table",
	templateUrl: "./bus-maintenance-student-table.component.html",
	styleUrls: ["./bus-maintenance-student-table.component.css"],
})
export class BusMaintenanceStudentTableComponent implements OnInit {
	constructor(
		private userService: UserService,
		private StudentService: DataService_BusTrackerBusMaintenance,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadPerson();
	}

	ngOnChanges() {
		this.loadPerson();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() Imported: any;
	@Input() SelectedRoute: any;

	Processing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPersons: any = [];
	lstPerson: any = [];

	//Filter lists
	lstSchoolFullName: any = [];
	lstDefinedByDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "StudentID", header: "Student ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "SchoolFullName", header: "School" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadPerson() {
		this.errorMessage = "";

		this.SelectedPersons = [];

		if (this.SelectedRoute == undefined) {
			this.lstPerson = [];
			return;
		}

		this.loading = true;

		var result = this.StudentService.StudentAssignedRouteSelectList(this.SelectedRoute.BusRouteID, this.user.userID);
		result.subscribe(
			(response) => {
				this.lstPerson = response;

				//Load Data Filter Lists
				this.lstSchoolFullName = Array.from(new Set(this.lstPerson.map((item: any) => item.SchoolFullName)));
				this.lstDefinedByDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.DefinedByDesc)));

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadPerson();
	}

	//Custom Button Methods
	onAdd() {
		this.errorMessage = "";

		if (this.Imported == true) {
			return;
		}

		var popup_Width = (window.innerWidth - 80).toString() + "px";

		var ref = this.dialogService.open(AssignStudentsComponent, {
			header: "Assign Students",
			width: popup_Width,
			data: {
				//INSERT Custom Data here
				SelectedRoute: this.SelectedRoute,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadPerson();
			}
		});
	}

	onRemove() {
		this.errorMessage = "";

		this.SelectedPersons = this.SelectedPersons.filter((person) => person.DefinedByID > 2 && person.IsMySchool == true);

		if (this.SelectedPersons.length == 0) {
			this.errorMessage = "Select students to remove from the route (NOTE: You can't remove imported students from a route)";
			return;
		}

		this.Processing = true;

		this.ConfirmDelete();
	}

	ConfirmDelete() {
		var MSG: any = "You are about to unassign " + this.SelectedPersons.length + " students. Do you want to continue?";

		this.confirmationService.confirm({
			key: "confirmstudentdelete",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: MSG,
			header: "Confirm Unassign Students",
			icon: "fa",
			accept: () => {
				this.FinishDelete();
			},
			reject: () => {
				this.Processing = false;
			},
		});
	}

	FinishDelete() {
		var lstIDs: number[] = [];

		for (var z = 0; z < this.SelectedPersons.length; z++) {
			var next = this.SelectedPersons[z];

			lstIDs = [...lstIDs, next.PersonID];
		}

		let parms: BTStudentRouteRequest = {
			BusRouteID: this.SelectedRoute.BusRouteID,
			lstPersonIDs: lstIDs,
			DefinedByID: 4,
		};

		var result = this.StudentService.StudentsUnassignFromRoute(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.onRowUnselect(null);
					this.loadPerson();
				} else {
					this.confirmationService.confirm({
						key: "student",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not unassign students.",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		// this.SelectedPerson = val.data;
	}
	onRowUnselect(val) {
		// this.SelectedPerson = null;
	}
	onRowDblClick(Person) {
		// this.SelectedPerson = Person;
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.Processing == true;
	}

	CanEdit() {
		if (this.SelectedRoute == undefined) {
			return false;
		} else {
			return true;
		}
	}

	////////////////////////////////////////////
}
